import React, { useEffect, useState } from 'react'
import { BASE_URL } from '../../../config/axios';
import axios from 'axios';
import { handleErrorToast } from '../../CustomFunctions';
import { AddEmployeeRole, DeleteRole, UpdateEmployeeRole } from './EmployeeRoleComponent';
import { SubCompany } from '../../FilterDropdown';

const EmployeeRoleTable = ({ subCompanyId }) => {

    const [roleList, setRoleList] = useState([]);
    const [toggleCompany, setToggleCompany] = useState(subCompanyId || "null");


    const [buffer, setBuffering] = useState(false);

    const getRole = async () => {
        try {
            setBuffering(true);
            const res = await axios.get(`${BASE_URL}/siteproject/rolebysubcompany/${toggleCompany}/`);
            setRoleList(res.data);
        } catch (error) {

            console.error(error);

        } finally {
            setBuffering(false);
        }
    }

    useEffect(() => {
        getRole();
    }, [toggleCompany]);
    return (
        <div>

            <div className="table-css-white-background">

                <div className="form-flex-wrap" style={{ overflow: "scroll" }}>
                    <div className="table-heading-flex justify-between" style={{ width: "100%" }}>
                        <div className="repo-heading font-weight500    font-size-heading pl15 mb0">
                            Employee Role
                        </div>
                        <div className='flex-row'>
                            {subCompanyId !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c"
                                &&
                                <SubCompany toggleCompany={toggleCompany} setToggleCompany={setToggleCompany} />
                            }
                            <AddEmployeeRole getData={getRole} subCompanyId={subCompanyId} />
                        </div>
                    </div>
                    <div className='table-box  scroll-container-table' style={{ width: "100%" }}>
                        <table className="table-css" >
                            <thead className="table-heading">
                                <tr className="custom-table-head-tr">
                                    <th className="table-heading-text text-left-sr">S.no.</th>
                                    <th className="table-heading-text text-center">Sub Company</th>
                                    <th className="table-heading-text text-center">Employee Role</th>
                                    <th className="table-heading-text text-right">Action</th>
                                </tr>
                            </thead>
                            {buffer ? (
                                <div className="spinner-bgdatil"></div>//buffering logic
                            ) : (
                                <tbody>
                                    {roleList
                                        .sort((a, b) =>
                                            a.role_name?.localeCompare(b.role_name, "en", {
                                                ignorePunctuation: true,
                                            })
                                        )
                                        .map((i, index) => (
                                            <React.Fragment key={index}>

                                                <tr className="custom-table-head-td">
                                                    <td className="table-body ">{index + 1}</td>
                                                    <td className="table-body text-center">{i.subCompany_title}</td>
                                                    <td className="table-body text-center ">{i.role_name}</td>
                                                    <td className="table-body text-right" style={{ justifyContent: 'right' }}>
                                                        <UpdateEmployeeRole
                                                            i={i}
                                                            getData={getRole}
                                                            subCompanyId={subCompanyId}



                                                        />
                                                        <DeleteRole
                                                            i={i}
                                                            getData={getRole} />
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        ))}
                                </tbody>
                            )}
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EmployeeRoleTable